import React from "react";

const SummaryInterest = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F6F8FA" />
      <path
        d="M13.25 25.2498V15.2748C13.25 15.1208 13.2973 14.9706 13.3856 14.8444C13.4739 14.7183 13.5988 14.6224 13.7435 14.5698L20.9967 11.9328C21.0534 11.9121 21.1142 11.9055 21.174 11.9134C21.2338 11.9212 21.2908 11.9434 21.3401 11.978C21.3895 12.0126 21.4298 12.0586 21.4577 12.1121C21.4855 12.1656 21.5 12.225 21.5 12.2853V16L26.237 17.5788C26.3864 17.6285 26.5164 17.7241 26.6084 17.8518C26.7005 17.9796 26.75 18.133 26.75 18.2905V25.2498H28.25V26.7498H11.75V25.2498H13.25ZM14.75 25.2498H20V13.891L14.75 15.8005V25.2498ZM25.25 25.2498V18.8313L21.5 17.581V25.2498H25.25Z"
        fill="#525866"
      />
    </svg>
  );
};

export default SummaryInterest;
